import React from 'react'; 

class NonUpdateFragment extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.progress == nextProps.progress) {
      return true;
    }
    return false;
  }
  render() {
    return <React.Fragment>
      {this.props.children}
    </React.Fragment>
  }
}
 

export default NonUpdateFragment;



// WEBPACK FOOTER //
// ./src/components/NonUpdateFragment.js